<div class="button_up" v-show="visible" @click="clickUp" :title="'To up'"></div>